<template>
  <div id="app">
    <a-spin :tip="spinningMessage" :spinning="spinning">
      <Header ref="header" />
      <Content>
        <router-view />
      </Content>
    </a-spin>
  </div>
</template>
<script>
import Header from "./components/header";
import Content from "./components/content";

import { confMon, callOutOther } from "@/services/conf";
import { isAuth } from "@/services/user";
import { qaList, qaFloorId } from "@/services/qa";

// import PartyWebworker from "@/services/party.worker";

import { PartyService } from "@/services/party.service";

import { END_PAGE } from "@/router";

import { buildOfflineUniqueId } from "@/model/conf/model";

import {
  MESSAGE_TYPE_UPDATE_ONLINE,
  MESSAGE_TYPE_UPDATE_OFFLINE,
  MESSAGE_TYPE_INIT_FINISH,
  MESSAGE_TYPE_RE_CONFMON
} from "@/model/worker/model";

import {
  wsDataBuildParty,
  getMeetingMuteEnable,
  getMeetingMuteDisable,
  getMeetingOnRecord,
  getMeetingRecordStart,
  getMeetingOffRecord,
  getMeetingPauseRecord,
  getMeetingLockEnable,
  getMeetingLockDisable,
  getMeetingBeingHeld,
  getMeetingEnd,
  getMeetingQaEnable,
  getMeetingQaDisable,
  getMeetingWaitLineEnable,
  getMeetingWaitLineConnect,
  getMeetingWaitLineDisable,
  getMeetingGuestMuteOverrideEnable,
  getMeetingGuestMuteOverrideDisable,
  meetingIsCancel,
  meetingIsUnStart
} from "@/model/conf/model";

import { custOnLine } from "@/model/conf/model";

import { JoinMeetingService } from "@/services/join-meeting.socket";
import {
  getConfStart,
  getConfEnd,
  getConfUnStart,
  getRecordStart,
  getOnRecord,
  getOffRecord,
  getPauseRecord,
  getStopQa,
  getStartQa,
  getUnLock,
  getLock,
  getUnMute,
  getMute,
  getConfStartWaitLine,
  getConfConnectionWaitLine,
  getConfStopWaitLine,
  getConfChairmanUnmute,
  getConfCustUnmute
} from "@/model/conf/socket/conf";

import { mapGetters } from "vuex";

export default {
  joinMeetingService: null,
  partyMessageProcess: null,
  partyWebworker: null,
  partyService: null,
  confMonEventHandle: {},
  components: {
    Header,
    Content
  },
  computed: {
    ...mapGetters(["offlinePartyListInfo", "isMeetingEnd"]),
    getAutoCall() {
      return this.$store.getters.autoCall;
    },
    meeting() {
      return this.$store.getters.meetingInfo;
    },
    partyList() {
      return this.$store.getters.partyListInfo;
    },
    authToken() {
      return this.$store.getters.authTokenInfo;
    },
    removePartyIdObject() {
      const removePartyIdObject = {};
      this.removePartyIdList.forEach(id => {
        removePartyIdObject[id] = true;
      });
      return removePartyIdObject;
    }
  },
  data() {
    return {
      showClose: false,
      removePartyIdList: [],
      spinning: false,
      spinningMessage: ""
    };
  },
  watch: {
    authToken: {
      handler: function(newVal) {
        if (newVal) {
          // this.init();
          this.bindSocket();
        }
      },
      // deep: true
      immediate: true
    }
  },
  created() {
    // 百应没有im，注释掉
    // this.$eventHub.$on("im-send-msg", this.sendMsg);
    this.bindWorker();
    this.initConfMonEventHandle();
  },
  beforeDestroy() {
    // 百应没有im，注释掉
    // this.$eventHub.$off("im-send-msg", this.sendMsg);
  },
  methods: {
    checkAuth() {
      // 检查是否已登录
      return isAuth();
    },
    showSpining(message) {
      this.spinning = true;
      this.spinningMessage = message;
    },
    hideSpining() {
      this.spinning = false;
    },
    getToken() {
      return this.$store.getters.authTokenInfo;
    },
    getConfMon() {
      this.showSpining("获取会议信息...");
      return confMon()
        .then(result => {
          this.hideSpining();
          this.handleConfMon(result);
        })
        .catch(error => {
          this.hideSpining();
          console.log(error);
          this.confError();
        });
    },
    handleConfMon(result) {
      if (meetingIsCancel(result.status)) {
        this.infoMeetingEnd();
      } else if (meetingIsUnStart(result.status)) {
        this.infoMeetingIsUnStart();
      } else if (null === result.billingCode) {
        this.apiError();
      } else {
        this.confMonSuccess(result);
      }
    },
    confMonSuccess(result) {
      this.partyService.initPartyList(result.partyList);
      // 初始化ping码
      this.initPinList(result.partyList);
      this.$store.commit("setMeetingInfo", result);
    },
    autoStartTime() {
      // 数据初始化完成后判断是否已开会
      if (this.meeting.firstJoinTime) {
        this.confStartTime();
      }
    },
    confError() {
      this.$info({
        title: "提示",
        content: "获取会议信息失败，请稍后再试。",
        onOk: () => {
          window.open("", "_self").close();
        }
      });
    },
    infoMeetingEnd() {
      this.setMeetingEnd();
      this.socketClose();
      this.$info({
        title: "提示",
        content: "会议已结束。",
        onOk: () => {
          this.toEndPage();
        }
      });
    },
    infoMeetingIsUnStart() {
      this.setMeetingEnd();
      this.socketClose();
      this.$info({
        title: "提示",
        content: "会议未开始。",
        onOk: () => {
          this.toEndPage(-2);
        }
      });
    },
    apiError() {
      this.$info({
        title: "提示",
        content: "接口数据错误，请稍后再试。",
        onOk: () => {
          window.location.reload();
        }
      });
    },
    initPinList(partyList) {
      const pinList = [];
      partyList.forEach(party => {
        if (party.pin !== null) {
          pinList.push({ showPhone: party.showPhone, pin: party.pin });
        }
      });
      this.$store.commit("setPinList", pinList);
    },
    autoCall() {
      // 百应自动呼叫
      if (this.getAutoCall) {
        const partyList = this.offlinePartyListInfo.map(party => {
          return {
            name: party.name,
            role: party.role,
            phone: party.phone,
            countryCode: party.countryCode,
            areaCode: party.areaCode
          };
        });
        callOutOther(this.meeting.bridgeName, partyList)
          .then(() => {
            this.$store.commit("setAutoCall", false);
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    getQa() {
      // 获取qa列表
      qaList()
        .then(result => {
          if (result && result.talkingPartyList) {
            this.$store.commit("setQaList", result.talkingPartyList);
          }
        })
        .catch(error => {
          console.log(error);
        });
      // 获取qa发言人列表
      qaFloorId()
        .then(result => {
          this.$store.commit(
            "setQaFloorParty",
            result.qaPartyId ? result.qaPartyId : null
          );
        })
        .catch(error => {
          console.log(error);
        });
    },
    bindWorker() {
      // this.partyWebworker = new PartyWebworker();
      // this.partyWebworker.onmessage = e => {
      //   this.$store.commit("replacePartyInfo", e.data.data);
      // };

      this.partyService = new PartyService();
      this.partyService.onmessage(e => {
        if (MESSAGE_TYPE_UPDATE_ONLINE === e.data.type) {
          this.$store.commit("replaceOnlinePartyInfo", e.data.data);
        } else if (MESSAGE_TYPE_UPDATE_OFFLINE === e.data.type) {
          this.$store.commit("replaceOfflinePartyInfo", e.data.data);
        } else if (MESSAGE_TYPE_INIT_FINISH === e.data.type) {
          this.autoCall();
          this.autoStartTime();
        } else if (MESSAGE_TYPE_RE_CONFMON === e.data.type) {
          // 重新获取confMon
          console.log("重新获取confMon");
          this.getConfMon()
            .then(() => {
              this.partyService.startHandleMessage();
            })
            .catch(err => {
              // 会议数据获取失败，点击刷新页面重试
              console.log(err);
            });
        }
        // else {
        //   this.$store.commit("replacePartyInfo", e.data.data);
        // }
      });
    },
    // 绑定外呼本地更新正在连接party消息
    bindCallOutPartyEvent() {
      // this.$eventHub.$on("call-out-party", partyList => {
      //   this.partyService.callOutParty(partyList);
      //   // this.partyWebworker.postMessage({
      //   //   type: "callOutParty",
      //   //   data: partyList
      //   // });
      // });
    },
    bindSocket() {
      if (this.joinMeetingService) {
        this.joinMeetingService.disconnect();
      }
      this.showSpining("获取系统连接...");
      this.joinMeetingService = new JoinMeetingService(
        this.authToken,
        () => {
          this.hideSpining();
          this.onJoinMeetingSocketConnect();
          this.getConfMon()
            .then(() => {
              // emit worker开始更新
              // this.partyWebworker.postMessage({
              //   type: "startHandleMessage"
              // });
              this.partyService.startHandleMessage();
              // this.autoCall(); // 百应自动呼叫
            })
            .catch(err => {
              // 会议数据获取失败，点击刷新页面重试
              console.log(err);
            });
          this.getQa();
        },
        () => {
          this.hideSpining();
          this.onJoinMeetingSocketDisconnect();
        }
      ); //
    },
    onJoinMeetingSocketConnect() {
      this.joinMeetingService.onConf(this.onConfEvent);
      this.joinMeetingService.onParty(this.onPartyEvent);
      this.joinMeetingService.onPartyTalk(this.onPartyTalkEvent);
      this.joinMeetingService.onQaList(this.onQaListEvent);
      this.joinMeetingService.onQaFloorParty(this.onQaFloorPartyEvent);
      this.joinMeetingService.onRemoveParty(this.onRemoveParty);
      this.joinMeetingService.onUpdatePartyRole(this.onUpdatePartyRole);
      this.joinMeetingService.onModifyPartyInfo(this.onModifyPartyInfo);
    },
    socketClose() {
      this.joinMeetingService.unReconnection();
      this.joinMeetingService.disconnect();
    },
    onJoinMeetingSocketDisconnect: (function() {
      let show = false;
      return function() {
        if (!show && !this.isMeetingEnd) {
          this.$info({
            okText: "重试",
            title: "提示",
            // JSX support
            content: "网络连接中断，请点击“重试”按钮尝试恢复连接！",
            onOk: () => {
              show = false;
              this.getConfMon(); // 重新获取会议信息
              // window.location.reload();
            }
          });
          show = true;
        }
      };
    })(),
    //参与人修改信息消息
    onModifyPartyInfo(jsonData) {
      const party = wsDataBuildParty(jsonData);
      const oldUniqueId = buildOfflineUniqueId(
        jsonData.oldAcmPhone,
        jsonData.participantId,
        party.id
      );
      const info = {
        oldUniqueId,
        name: party.name,
        nameLetters: party.nameLetters,
        countryCode: party.countryCode,
        areaCode: party.areaCode,
        phone: party.phone,
        showPhone: party.showPhone,
        uniqueId: party.uniqueId,
        id: party.id
      };

      this.partyService.modifyPartyInfo(info);
      // 更新对应参会人信息
    },
    //参与人修改角色消息
    onUpdatePartyRole(jsonData) {
      const party = wsDataBuildParty(jsonData);

      this.partyService.updatePartyRole(party);

      // 更新对应参会人角色
    },
    //参与人移除消息
    onRemoveParty(jsonData) {
      if (jsonData.partyList && jsonData.partyList.length > 0) {
        const partyList = jsonData.partyList.map(data =>
          wsDataBuildParty(data)
        );
        this.partyService.deleteParty(partyList);
      }
    },
    initConfMonEventHandle() {
      this.confMonEventHandle = {
        [getConfStart()]: this.meetingStart,
        [getConfUnStart()]: this.meetingUnStart,
        [getConfEnd()]: this.meetingEnd,
        [getRecordStart()]: this.meetingRecordStart,
        [getOnRecord()]: this.meetingOnRecord,
        [getOffRecord()]: this.meetingOffRecord,
        [getPauseRecord()]: this.meetingPauseRecord,
        [getStopQa()]: this.meetingStopQa,
        [getStartQa()]: this.meetingStartQa,
        [getUnLock()]: this.meetingUnLock,
        [getLock()]: this.meetingLock,
        [getUnMute()]: this.meetingUnMute,
        [getMute()]: this.meetingMute,
        [getConfStartWaitLine()]: this.meetingStartWaitLine,
        [getConfConnectionWaitLine()]: this.meetingConnectionWaitLine,
        [getConfStopWaitLine()]: this.meetingStopWaitLine,
        [getConfCustUnmute()]: this.meetingCustUnmute,
        [getConfChairmanUnmute()]: this.meetingChairmanUnmute
      };
    },
    onConfEvent(data) {
      const status = parseInt(data.status);
      try {
        if (this.confMonEventHandle[status]) {
          this.confMonEventHandle[status]();
        }
      } catch (err) {
        console.log(err);
      }
    },
    //会议说话列表消息
    onPartyTalkEvent(data) {
      this.$store.commit(
        "setPartyTalkList",
        data.talkingPartyList ? data.talkingPartyList : []
      );
    },
    //参与人消息
    onPartyEvent(data) {
      try {
        const party = wsDataBuildParty(data);
        this.partyService.partyMessage(party);
        if (custOnLine(party.status)) {
          // 会议启动计时
          this.confStartTime();
        }
      } catch (e) {
        console.log(data);
        console.log(e);
      }
    },
    confStartTime() {
      if (this.$refs.header) {
        this.$refs.header.$emit("confStartTime");
      }
    },
    buildPartyInfo(eventData) {
      const partyInfo = wsDataBuildParty(eventData);

      return partyInfo;
    },
    //当前会议问答发言的参与人消息
    onQaFloorPartyEvent(data) {
      if (data) {
        this.$store.commit(
          "setQaFloorParty",
          data.qaFloorParty ? data.qaFloorParty : null
        );
      }
    },
    //会议问答举手列表消息
    onQaListEvent(data) {
      if (data) {
        if (!data.qaPartyList) {
          data.qaPartyList = [];
        }
        this.$store.commit("setQaList", data.qaPartyList);
      }
    },
    // findParty(showPhone) {
    //   return this.partyShowPhoneObjectList[showPhone];
    // },
    partyIsRemoved(showPhone) {
      return true === this.removePartyIdObject[showPhone];
      // const index = this.removePartyIdList.indexOf(showPhone);
      // return index !== -1;
    },
    meetingStart() {
      this.$store.commit("setMeetingStatus", getMeetingBeingHeld());
    },
    meetingUnStart() {
      if (!this.showClose) {
        this.showClose = true;
        this.setMeetingEnd();
        this.socketClose();
        this.$info({
          title: "提示",
          content: "会议未开始。",
          onOk: () => {
            this.toEndPage(-2);
          }
        });
      }
    },
    meetingEnd() {
      this.$store.commit("setMeetingStatus", getMeetingEnd());
      // 设置所有参会人挂断电话状态
      this.$store.commit("allCustHangup");
      // 初始化会议状态
      this.$store.commit("setMeetingMuteStatus", getMeetingMuteDisable());
      this.$store.commit("setMeetingRecordStatus", getMeetingOffRecord());
      this.$store.commit("setMeetingLockStatus", getMeetingLockDisable());
      this.$store.commit("setMeetingQaStatus", getMeetingQaDisable());

      this.$refs.header.$emit("meeting-end");

      // 弹出会议结束提醒
      if (!this.showClose) {
        this.showClose = true;
        this.setMeetingEnd();
        this.socketClose();
        this.$info({
          title: "提示",
          content: "会议已结束。",
          onOk: () => {
            this.toEndPage();
          }
        });
      }
    },
    setMeetingEnd() {
      this.$store.commit("setMeetingEnd", true);
    },
    toEndPage(status = "") {
      // this.socketClose();
      this.$router.push({ name: END_PAGE, query: { status } });
      this.$store.commit("setMeetingEnd", true);
    },
    meetingMute() {
      this.$store.commit("setMeetingMuteStatus", getMeetingMuteEnable());
    },
    meetingUnMute() {
      this.$store.commit("setMeetingMuteStatus", getMeetingMuteDisable());
    },
    meetingOnRecord() {
      this.$store.commit("setMeetingRecordStatus", getMeetingOnRecord());
    },
    meetingRecordStart() {
      this.$store.commit("setMeetingRecordStatus", getMeetingRecordStart());
    },
    meetingRecordStarting() {
      this.$store.commit("setMeetingRecordStatus", getMeetingOnRecord());
    },
    meetingOffRecord() {
      this.$store.commit("setMeetingRecordStatus", getMeetingOffRecord());
    },
    meetingPauseRecord() {
      this.$store.commit("setMeetingRecordStatus", getMeetingPauseRecord());
    },
    meetingLock() {
      this.$store.commit("setMeetingLockStatus", getMeetingLockEnable());
    },
    meetingUnLock() {
      this.$store.commit("setMeetingLockStatus", getMeetingLockDisable());
    },
    meetingStartQa() {
      this.$store.commit("setMeetingQaStatus", getMeetingQaEnable());
    },
    meetingStopQa() {
      this.$store.commit("setMeetingQaStatus", getMeetingQaDisable());
    },
    meetingStopWaitLine() {
      this.$store.commit(
        "setMeetingWaitLineStatus",
        getMeetingWaitLineDisable()
      );
    },
    meetingStartWaitLine() {
      this.$store.commit(
        "setMeetingWaitLineStatus",
        getMeetingWaitLineEnable()
      );
    },
    meetingConnectionWaitLine() {
      this.$store.commit(
        "setMeetingWaitLineStatus",
        getMeetingWaitLineConnect()
      );
    },
    meetingChairmanUnmute() {
      this.$store.commit(
        "setMeetingGuestMute",
        getMeetingGuestMuteOverrideDisable()
      );
    },
    meetingCustUnmute() {
      this.$store.commit(
        "setMeetingGuestMute",
        getMeetingGuestMuteOverrideEnable()
      );
    }
  }
};
</script>

<style lang="less">
body {
  background-color: #f2f2f2 !important;
}
#app {
  font-family: Microsoft YaHei, PingFangSC-Regular, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  height: 100%;
  min-height: 600px;
  // min-width: 1400px;
  .ant-spin-nested-loading {
    display: flex;
    width: 100%;
    height: 100%;
    > :first-child {
      position: absolute;
    }
    > div {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
